/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_OrdersInputs */

const vi_report_debt_orders = /** @type {(inputs: Report_Debt_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số đơn`)
};

/**

* @param {Report_Debt_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_orders = /** @type {((inputs?: Report_Debt_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_orders(inputs)
});